// Redux =>
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Actions =>
// Components =>
import Button from '@Shared/Button';

// Iconst
import { IoCopyOutline } from 'react-icons/io5';

// Toast
import { toast } from 'react-toastify';

const CardTransfer = ({ cart: { basket }, cancel, handleSubmit }) => {

    const dataTransfer = {
        bank: 'BBVA Bancomer',
        name: 'Ivan Palacios Gabriel',
        clabe: '012180004632389032',
        card: '4152314150772401',
        contact: '+525584053109',
    }

    const copy = (text) => {
        navigator.clipboard.writeText(text);
        toast.success('😎 ¡Copiado!', { position: "bottom-center" });
    }

    const redirectToWhatsApp = () => {
        window.open(`https://wa.me/${dataTransfer.contact}?text=Confirmacion de pago por ${basket?.sum_primary}, adjunto el comprobante de pago.`, '_blank');
        toast.success('😎 ¡Redirigiendo a WhatsApp!', { position: "bottom-center" });
    }


    return (
        <div id='card-transfer'>
            <div className='content'>
                <h2>Transferencias y Depósitos</h2>

                <div className='summary'>
                    <h1>Total a pagar</h1>
                    <p>${basket?.sum_primary}</p>
                </div>

                <div className='instructions'>
                    <h3>Instrucciones:</h3>
                    <p>Realiza el depósito y/o transferencia de la cantidad exacta total de tu compra en la cuenta bancaria de la tienda.</p>
                </div>

                <div className='transfer-info'>
                    <h3>Información bancaria para el pago</h3>
                    <ul>
                        <li>
                            <b>Banco:</b>
                            <span>
                                <span data-copy={dataTransfer.bank}>{dataTransfer.bank}</span>
                            </span>
                        </li>
                        <li>
                            <b>Titular:</b>
                            <span>
                                <IoCopyOutline size={18} style={{ marginRight: 5 }} onClick={() => copy(dataTransfer.name)} />
                                <span data-copy={dataTransfer.name}>{dataTransfer.name}</span>
                            </span>
                        </li>
                        <li>
                            <b>Clabe (Transferencias):</b>
                            <span className='copy'>
                                <IoCopyOutline size={18} style={{ marginRight: 5 }} onClick={() => copy(dataTransfer.clabe)} />
                                <span data-copy={dataTransfer.clabe}>{dataTransfer.clabe}</span>
                            </span>
                        </li>
                        <li>
                            <b>No. de tarjeta (Depósitos):</b>
                            <span className='copy'>
                                <IoCopyOutline size={18} style={{ marginRight: 5 }} onClick={() => copy(dataTransfer.card)} />
                                <span data-copy={dataTransfer.card}>{dataTransfer.card}</span>
                            </span>
                        </li>
                    </ul>
                </div>

                <div className='confirmation'>
                    <h3>Importante!!!</h3>
                    <p>Una vez que hayas realizado el depósito, envíanos tu comprobante de pago, a nuestro medio de comunicación oficial. Una vez que la tienda reciba el depósito, tu pedido será confirmado por ese mismo medio.</p>
                </div>

                <div className='link-whatsapp'>
                    <h3>Medios de comunicación oficial</h3>
                    <ul>
                        <li className='whatsapp'>
                            <b>WhatsApp:</b>
                            <span>
                                <div>
                                    <IoCopyOutline size={18} style={{ marginRight: 5 }} onClick={() => copy(dataTransfer.contact)} />
                                    <span data-copy={dataTransfer.contact}>{dataTransfer.contact}</span>
                                </div>
                                <div className='button'>
                                    <Button variant={'tertiary'} onClick={redirectToWhatsApp}>Enviar comprobante</Button>
                                </div>
                            </span>
                        </li>
                    </ul>
                </div>

                <div className='buttons'>
                    <Button variant={'primary'} onClick={handleSubmit}>Confirmar pago</Button>
                    <Button onClick={cancel} variant={'link'}>Regresar</Button>
                </div>

            </div>
        </div>
    );
};

// mapStateToProps =>
function mapStateToProps(state) {
    return state;
}

// Bind actions to be used along redux =>
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        // Actions
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(CardTransfer);
